import * as React from "react";
import { cn } from "@/utils/tailwind";

export interface Props extends Omit<
  React.SVGAttributes<SVGElement>,
  "children"
> {}

export const NotificationDot = React.forwardRef<SVGSVGElement, Props>(
  ({ className, ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        className={cn("relative -top-1 -left-1", className)}
        {...props}
        ref={forwardedRef}
      >
        <circle
          cx="4"
          cy="4"
          r="3.69231"
          fill="#F04438"
          stroke="#D92D20"
          stroke-width="0.615385"
        />
      </svg>
    );
  },
);
